module.exports = {
  __init__: [
    'appendBehavior',
    'createParticipantBehavior',
    'createBoundaryEventBehavior',
    'createOnFlowBehavior',
    'replaceConnectionBehavior',
    'removeBehavior',
    'modelingFeedback'
  ],
  appendBehavior: [ 'type', require(22) ],
  createParticipantBehavior: [ 'type', require(25) ],
  createBoundaryEventBehavior: [ 'type', require(23) ],
  createOnFlowBehavior: [ 'type', require(24) ],
  replaceConnectionBehavior: [ 'type', require(28) ],
  removeBehavior: [ 'type', require(27) ],
  modelingFeedback: [ 'type', require(26) ]
};
